import App from 'App/translations/en.js';
import routesLoginPage from 'routes/Public/LoginPage/translations/en.js';
import routesDriverLoginPage from 'routes/Public/DriverLoginPage/translations/en.js';
import routesDriverDocumentsPage from 'routes/Driver/DriverDocumentsPage/translations/en.js';
import routesResetPasswordPage from 'routes/Public/ResetPasswordPage/translations/en.js';
import requestDocumentForm from 'features/Dashboard/Request/RequestForm/translations/en.js';
import registrationByInviteLinkPage from 'routes/Public/RegistrationByInviteLinkPage/translations/en.js';
import userProfileForm from 'features/Dashboard/UserProfile/UserProfileForm/translations/en.js';
import driverProfileForm from 'features/Driver/DriverProfile/DriverProfileForm/translations/en.js';

export default {
  ...App,
  ...routesLoginPage,
  ...routesResetPasswordPage,
  ...routesDriverLoginPage,
  ...routesDriverDocumentsPage,
  ...requestDocumentForm,
  ...registrationByInviteLinkPage,
  ...userProfileForm,
  ...driverProfileForm,
};
